import { render, staticRenderFns } from "./TotalValueIndicator.vue?vue&type=template&id=fa02ae7a&scoped=true&"
import script from "./TotalValueIndicator.vue?vue&type=script&lang=js&"
export * from "./TotalValueIndicator.vue?vue&type=script&lang=js&"
import style0 from "./TotalValueIndicator.vue?vue&type=style&index=0&id=fa02ae7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa02ae7a",
  null
  
)

export default component.exports